import QRCode from "qrcode.react"
import { Box } from "@mui/material"

type StandardQRCodeProps = {
    url: string
    size?: number
    level?: string
    includeMargin?: boolean
}

export const StandardQRCode = ({ url, size = 90, level = "H", includeMargin = true }: StandardQRCodeProps) => {
    return (
        <Box>
            <QRCode value={url} size={size} level={level} includeMargin={includeMargin} />
        </Box>
    )
}
